import axios from 'axios';
import { NETWRK_API_URL_PROD } from 'constants/index';

import { envDetector } from './env';

export const mirrorSignUpToNetwrk = (payload: { email: string; userName: string }): void => {
  const baseUrl = envDetector() ? NETWRK_API_URL_PROD : undefined;

  if (!baseUrl) {
    return;
  }

  axios.post(`${baseUrl}/auth/partners/smashhaus/signup`, payload).catch(error => {
    console.warn('Netwrk mirror failed for signup; SmashHaus signup unaffected', error);
  });
};
